import { AppThunk } from 'redux/reducers/rootReducer';
import { ITableData } from 'types/backend_models/shared/ITableData';
import { IDocument } from 'types/backend_models/documents/IDocument';
import { IGenericDataFetchParams, createGenericDataFetch } from '../../generic/GenericDataActions';
import { 
	// initialState, 
	setFetchProductDocumentsPending, setFetchProductDocumentsSucces, setFetchProductDocumentsError } from 'redux/reducers/data_action_reducers/products/detail/ProductDocumentsReducer';

// const defaultQueryData = {
// 	sorted: '',
// 	filters: [],
// 	currentPage: initialState.data.currentPage,
// 	pageSize: initialState.data.pageSize
// }

// Product owner type id
// const docOwnerTypeId = 1;

var fetchParams: IGenericDataFetchParams<ITableData<IDocument[]>> = {
	apiEndPoint: '',
	pendingActionCreator: setFetchProductDocumentsPending,
	succesActionCreator: setFetchProductDocumentsSucces,
	errorActionCreator: setFetchProductDocumentsError,
	logResult: false
}

export function fetchProductDocuments(productId: number): AppThunk
{
	// let filters = `documentownertypeid==${docOwnerTypeId}, documentownerid==${productId}`;
	// const query = `?Page=${defaultQueryData.currentPage}&PageSize=${defaultQueryData.pageSize}&filters=${filters}`;
	fetchParams.apiEndPoint = `customer/products/${productId}/documents`;

	return createGenericDataFetch<ITableData<IDocument[]>>(fetchParams);
}